var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"ui bottom attached button",attrs:{"href":_vm.link,"rel":"noopener","target":"_blank"}},[_c('i',{staticClass:"external alternate icon"}),_vm._v(" Etherscan ")])}
var staticRenderFns = []

export { render, staticRenderFns }